import { Table as ReactTable } from '@tanstack/react-table';
import * as _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { IsolatedMultiSelect } from 'packages/common-frontend/components/MultiSelect';

export const createColumnVisibility = ({
  columnDefs,
  selectedOptions,
}: {
  columnDefs: string[];
  selectedOptions: string[];
}) => {
  const columnVisibility: { [key: string]: boolean } = {};
  _.forEach(columnDefs, (key) => {
    if (selectedOptions.includes(key)) {
      columnVisibility[key] = true;
    } else {
      columnVisibility[key] = false;
    }
  });

  return columnVisibility;
};

type ColumnSelectorProps = { tableInstance: ReactTable<any> };
export const ColumnSelector = ({ tableInstance }: ColumnSelectorProps) => {
  const onApplyOptions = (selectedOptions: string[]) => {
    const newColumnVisibility = createColumnVisibility({
      columnDefs: _.map(tableInstance.getAllLeafColumns(), 'id'),
      selectedOptions,
    });

    tableInstance.setColumnVisibility(newColumnVisibility);
  };

  const options = _.compact(
    _.map(tableInstance.getAllLeafColumns(), (column) => {
      // in the case where the column header (headerKey) and id (accessorKey) differ
      const header = column.columnDef.header ?? column.id;
      return {
        label: commonUtils.toSentenceCase(
          typeof header === 'string' ? header : column.id,
        ),
        value: column.id,
      };
    }),
  );

  const initialSelections = _.compact(
    _.map(tableInstance.getAllLeafColumns(), (column) => {
      return column.getIsVisible() ? column.id : null;
    }),
  );

  return (
    <IsolatedMultiSelect
      applyButtonText="Display selected columns"
      buttonProps={{
        colorScheme: 'gray',
        variant: 'secondary-muted',
        minWidth: '250px',
      }}
      initialSelections={initialSelections}
      isSearchable
      menuListProps={{ zIndex: 'dropdown' }}
      onApplyOptions={onApplyOptions}
      options={options}
      optionsHeader="Properties"
      placeholderText="Select properties"
      showSelectedCount
      titleFontWeight="semibold"
      titleText="Show/Hide Columns"
      counterLabel="Show/Hide"
      disabledOptionValues={['externalreceivableid']}
    />
  );
};
